var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"text-2xl font-black font-lato mb-4"},[_vm._v("Branches "),_c('span',{staticClass:"rounded-full text-lg bg-white text-black px-2 ml-2"},[_vm._v(_vm._s(_vm.branches.length))])]),_c('div',{staticClass:"grid"},_vm._l((_vm.branches),function(branch){return _c('BranchCard',{key:branch.id,attrs:{"branch":branch}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }